module.exports = __webpack_public_path__ + "static/ice-right-687a4b0435227b63f5b4e6cd99be227e.webp";